export default "__VITE_ASSET__BHAmdN1i__"